var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { fetchObjectStoreUsages } from "@/api/users";
import localize from "@/utils/localization";
import { byteFormattingForChart, useDataLoading } from "./util";
import BarChart from "./Charts/BarChart.vue";
import ObjectStoreActions from "./ObjectStoreActions.vue";
import OverviewPage from "./OverviewPage.vue";
import ShowObjectStore from "./ShowObjectStore.vue";
import WarnDeletedHistories from "./WarnDeletedHistories.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoresStorageOverview',
    setup(__props) {
        const router = useRouter();
        const objectStoresBySizeData = ref(null);
        const { isLoading, loadDataOnMount } = useDataLoading();
        loadDataOnMount(() => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield fetchObjectStoreUsages({ user_id: "current" });
            const objectStoresBySize = data.sort((a, b) => b.total_disk_usage - a.total_disk_usage);
            objectStoresBySizeData.value = objectStoresBySize.map((objectStore) => ({
                id: objectStore.object_store_id,
                label: objectStore.object_store_id,
                value: objectStore.total_disk_usage,
            }));
        }));
        function onViewObjectStore(objectStoreId) {
            router.push({ name: "ObjectStoreOverview", params: { objectStoreId } });
        }
        return { __sfc: true, router, objectStoresBySizeData, isLoading, loadDataOnMount, onViewObjectStore, localize, byteFormattingForChart, BarChart, ObjectStoreActions, OverviewPage, ShowObjectStore, WarnDeletedHistories, LoadingSpan };
    }
});
